<template>
  <div>
    <template v-if="!status.fragebogenIstVersendet && !status.laedt && !fragebogenUengueltig">
      <FragebogenModule
        ref="fragebogenModule"
        :fragebogenIdentifier="fragebogenIdentifier"
        @error="fragebogenUengueltig = true"
        ausfuellerSicht
      >
      </FragebogenModule>

      <div class="fragebogenButtons">
        <v-row style="text-align: right">
          <v-col>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <b-btn class="mr-6" v-on="on" @click="zeigeZuruecksetzenPopup()"
                  >Formular zuruecksetzen</b-btn
                >
              </template>
              <span>{{ tooltips.zuruecksetzen }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <b-btn class="mr-6" v-on="on" @click="fragebogenSpeichern()"
                  >Speichern</b-btn
                >
              </template>
              <span>{{ tooltips.speichern }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <b-btn v-on="on" @click="zeigeVersendenPopup = true"
                  >Versenden</b-btn
                >
              </template>
              <span>{{ tooltips.versenden }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <FragebogenVersendenPopup
          v-if="zeigeVersendenPopup"
          text="Sind Sie sich sicher, dass Sie den Fragenbogen versenden wollen?"
          @cancel="zeigeVersendenPopup = false"
          @versenden="fragebogenVersenden()"
        />
        <v-snackbar
          v-model="snackbar.show"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
        >
          {{ snackbar.text }}
        </v-snackbar>
      </div>
    </template>
    <template v-else-if="!status.laedt">
      <v-row v-if="Object.keys(projekt).length != 0" class="pl-3">
        <v-col class="pa-1 pb-3">
          <h2>Fragebogen zu {{ projekt.titel }}</h2>
        </v-col>
      </v-row>
      <b-unit>
        <div class="fragebogenAbgeschickt">
          <h3 v-if="status.fragebogenIstVersendet">
            Vielen Dank für Ihre Angaben zur Verwertung Ihrer Projektergebnisse.
            Wenn die Verwertung noch nicht abgeschlossen ist, werden wir Sie in
            einigen Monaten nochmal per Mail darum bitten Ihre Angaben zu
            ergänzen.
          </h3>
          <h3 v-else>Dieser Link ist derzeit nicht gültig!</h3>
        </div>
      </b-unit>
    </template>
    <BestaetigenPopup
        v-if="zeigeZuruecksetzenBestaetigenPopup"
        infoText="Wollen Sie den Fragebogen wirklich zurücksetzen?"
        @cancel="zeigeZuruecksetzenBestaetigenPopup = false"
        @confirm="fragebogenZuruecksetzen()"
    />
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import FragebogenModule from '@/views/fragebogen/FragebogenModule';
import axios from 'axios';
import FragebogenVersendenPopup from '@/components/popups/FragebogenVersendenPopup';
import BestaetigenPopup from '@/components/popups/BestaetigenPopup';
import tooltips_text from '@/utils/data/tooltips';
import _ from 'lodash';

export default {
  name: 'FragebogenAusfuellerSicht',
  components: { FragebogenModule, FragebogenVersendenPopup, BestaetigenPopup },
  props: {
    uuid: {
      type: [Number, String],
    },
  },
  data() {
    return {
      fragebogenIdentifier: {
        typ: `fragebogen/link/${this.uuid}`,
      },
      snackbar: {
        show: false,
        color: '',
        text: '',
        timeout: 4000,
      },
      status: {
        fragebogenIstVersendet: false,
        linkGueltig: false,
        laedt: false, //neue lösung finden
      },
      aktionen: {
        versenden: false,
        zuruecksetzen: false,
      },
      zeigeVersendenPopup: false,
      tooltips: tooltips_text,
      fragebogenUengueltig: false,
      zeigeZuruecksetzenBestaetigenPopup: false
    };
  },
  created: function () {
    //this.ladeFragebogenStatus();
  },
  computed: {
    oeffneSnackbarErfolg() {
      return (response) => {
        if (200 <= response.statusCode < 300) {
          this.snackbar.color = `primary`;
          this.snackbar.text = this.aktionen.versenden
            ? `Erfolgreich fragebogenIstVersendet`
            : `Erfolgreich gespeichert`;
          this.snackbar.show = true;
          if (this.aktionen.versenden)
            this.status.fragebogenIstVersendet = true;
          this.aktionenZuruecksetzen();
        }
      };
    },
    oeffneSnackbarFehlschlag() {
      return (err) => {
        this.snackbar.color = `red`;
        this.snackbar.text =
          `${err.response.status}` +
          (this.aktionen.versenden
            ? ` Fehler beim versenden`
            : this.aktionen.zuruecksetzen
            ? ` Fehler beim zurücksetzen`
            : ` Fehler beim speichern`);
        this.snackbar.show = true;
        this.aktionenZuruecksetzen();
      };
    },
  },
  mixins: [
    //ProjektStammdaten
    dataMixin('fragebogen', 'loadedData.fragebogen'),
    dataMixin('projekt', 'persistentData.projekt', {}),
  ],
  methods: {
    zeigeZuruecksetzenPopup() {
      this.zeigeZuruecksetzenBestaetigenPopup = true;
    },
    fragebogenZuruecksetzen() {
      this.aktionen.zuruecksetzen = true;
      axios
        .post(`/v1/fragebogen/reset/${this.fragebogen.id}`)
        .then((response) => {
          if (200 <= response.statusCode < 300) {
            this.fragebogen = _.cloneDeep(response.data);
            this.$refs.fragebogenModule.neuLaden();
          }
        }, this.oeffneSnackbarFehlschlag);
    },
    fragebogenSpeichern() {
      let payload = _.cloneDeep(this.fragebogen);
      axios
        // .put(`/v1/fragebogen/${this.fragebogen.id}`, payload)
        .put(`/v1/fragebogen/link/${this.uuid}`, payload)

          .then(
            (response) => this.oeffneSnackbarErfolg(response),
            (err) => this.oeffneSnackbarFehlschlag(err)
          );
    },
    fragebogenVersenden() {
      this.aktionen.versenden = true;
      let payload = _.cloneDeep(this.fragebogen);
      payload.abgeschickt = true;
      // payload.zwischenstand.position += 1;
      payload.zwischenstand.letzteÄnderung = null;
      axios
        .put(`/v1/fragebogen/sendfinal/${this.uuid}`, payload)
        // .put(`/v1/fragebogen/sendfinal/{id}?id=${this.fragebogen.id}`, payload)
        .then(
          (response) => this.oeffneSnackbarErfolg(response),
          (err) => this.oeffneSnackbarFehlschlag(err)
        );
      this.ladeFragebogenStatus();
    },

    /*ladeFragebogenStatus() {
      axios.get(`/v1/fragebogen/istOffen?id=${this.uuid}`).then((response) => {
        this.status.linkGueltig = response.data;
        this.status.laedt = false;
      });
    },*/

    aktionenZuruecksetzen() {
      this.aktionen = {
        versenden: false,
        zuruecksetzen: false,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.fragebogenAusfuellerSicht {
  padding-bottom: 60px;
  h2 {
    margin-bottom: 20px;
  }
  .fragebogenHeader {
    margin-bottom: 20px;
  }
  .fragebogenAbschnitt {
    margin-bottom: 20px;
    .frage {
      margin-bottom: 20px;
      .button {
        text-transform: none;
        padding: 0 0 0 10px;
        height: 30px;
      }
    }
  }
}

.fragebogenAbgeschickt {
  padding: 50px 0;
  font-size: 18px;
  h3 {
    text-align: center;
  }
}
</style>